import * as React from 'react';

export function FileTextIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			strokeLinejoin='round'
			strokeLinecap='round'
			strokeWidth={2}
			stroke='currentColor'
			fill='none'
			viewBox='0 0 24 24'
			width={24}
			height={24}
			{...props}
		>
			<path d='M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z' />
			<path d='M14 2v5a1 1 0 0 0 1 1h5' />
			<path d='M10 9H8' />
			<path d='M16 13H8' />
			<path d='M16 17H8' />
		</svg>
	);
}
